import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import {
Col,
Row,
} from "reactstrap";
import {
GET_RP_OVERUSE_SHIPPER,
GET_SHIPPER,
} from "../../../helpers/url_api_constant";
import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import TableOveruseByShipper from "./TableOveruseByShipper";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function OveruseByShipper(props) {
  //   console.log(props);
  const dispatch = useDispatch();
 

  const [dataList, setDataList] = useState([])
  useEffect(() => {
    fetchData();
  }, [props.summaryReportPid]);
  useEffect(() => {

  }, [props.date]);

  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number)) return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }

  const fetchData = async () => {
    function compare(a, b) {
      if (a.PRIORITY_FLAG < b.PRIORITY_FLAG) {
        return -1;
      }
      if (a.PRIORITY_FLAG > b.PRIORITY_FLAG) {
        return 1;
      }
      return 0;
    }
    dispatch(loadingAction.showLoading());
    try {
      let [res1, res2] = await Promise.all([
        post(GET_RP_OVERUSE_SHIPPER, { SUMMARYREPORT_PID: props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682" })
        , post(GET_SHIPPER, {})
      ])
      let data = res1.data.RPOversureShipperList.map(row=>({ ...row,
        OVERUSE_ACTUAL: Math.round(row.OVERUSE_ACTUAL),
        OVERUSE_BOOKING: Math.round(row.OVERUSE_BOOKING),
        OVERUSE:row.OVERUSE_ACTUAL> row.OVERUSE_BOOKING? Math.round(row.OVERUSE_ACTUAL )-Math.round(row.OVERUSE_BOOKING ):0,
      }))
      // console.log(data)
      let masterCustomerList = res2.data.customerList;
      let shipperList = data.map((item, index) => {
        let shipperData = masterCustomerList.find((row) => row.CONTACT_CODE == item.OVERUSESHIPPER_NAME)
        return {
          SHIPPER_NAME: shipperData?.FULL_NAME,
          PID: item.OVERUSESHIPPER_PID,
          PRIORITY_FLAG: item.OVERUSESHIPPER_ORDER,
        }
      }).sort(compare);
  
      shipperList = [...new Map(shipperList.map(item =>
        [item['PID'], item])).values()];
//         shipperList =[
//           {
//             "SHIPPER_NAME": "PTT2",
//             "PID": "6dad9b92-4b4d-4211-8687-152cfbe1d921",
//             "PRIORITY_FLAG": 0
//           },
//           {
//             "SHIPPER_NAME": "PTT",
//             "PID": "6dad9b92-4b4d-4211-8687-152cfbe1d921",
//             "PRIORITY_FLAG": 1
//         },{
//           "SHIPPER_NAME": "EGAT",
//           "PID": "6dad9b92-4b4d-4211-8687-152cfbe1d921",
//           "PRIORITY_FLAG": 2
//       },{
//         "SHIPPER_NAME": "test1",
//         "PID": "6dad9b92-4b4d-4211-8687-152cfbe1d921",
//         "PRIORITY_FLAG": 3
//     },{
//       "SHIPPER_NAME": "test2",
//       "PID": "6dad9b92-4b4d-4211-8687-152cfbe1d921",
//       "PRIORITY_FLAG": 4
//   },{
//     "SHIPPER_NAME": "test3",
//     "PID": "6dad9b92-4b4d-4211-8687-152cfbe1d921",
//     "PRIORITY_FLAG": 5
// },{
//   "SHIPPER_NAME": "test4",
//   "PID": "6dad9b92-4b4d-4211-8687-152cfbe1d921",
//   "PRIORITY_FLAG": 5
// },{
//   "SHIPPER_NAME": "test5",
//   "PID": "6dad9b92-4b4d-4211-8687-152cfbe1d921",
//   "PRIORITY_FLAG": 5
// }]
        // console.log( shipperList.length%4 ,true)
    // console.log(data,shipperList)
        shipperSplit(data,shipperList)
     
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());

  }

  const shipperSplit = (data,shipperList) => {
    function compare(a, b) {
      if (a.PRIORITY_FLAG < b.PRIORITY_FLAG) {
        return -1;
      }
      if (a.PRIORITY_FLAG > b.PRIORITY_FLAG) {
        return 1;
      }
      return 0;
    }
    function compareArea(a, b) {
      if (a.OVERUSE_AREA < b.OVERUSE_AREA) {
        return -1;
      }
      if (a.OVERUSE_AREA > b.OVERUSE_AREA) {
        return 1;
      }
      return 0;
    }
    function splitShipper(data,shipperList){

      let entryData = data.filter(item => {
        const indexOfShipper = shipperList.findIndex(shipper => {
          return shipper.PID === item.OVERUSESHIPPER_PID;
        });
  
        return item.OVERUSE_POINT.toLowerCase() == 'entry' && indexOfShipper >= 0
      })
      let exitData = data.filter(item => {
  
        const indexOfShipper = shipperList.findIndex(shipper => {
          return shipper.PID === item.OVERUSESHIPPER_PID;
        });
  
        return item.OVERUSE_POINT.toLowerCase() == 'exit' && indexOfShipper >= 0
      })
  // console.log(exitData)
  
      let entryDataList = entryData.map(row => {
        let obj = shipperList.find(shipper => shipper.PID == row.OVERUSESHIPPER_PID)
        return { ...row, ...(obj && { SHIPPER_PRIORITY_FLAG: obj.PRIORITY_FLAG }) }
      })
      let exitDataList = exitData.map(row => {
        let obj = shipperList.find(shipper => shipper.PID == row.OVERUSESHIPPER_PID)
        return { ...row, ...(obj && { SHIPPER_PRIORITY_FLAG: obj.PRIORITY_FLAG }) }
      })
  
  
  
  
      let total1 = entryDataList.sort(compare).reduce((r, a) => {
  
        r[a.OVERUSESHIPPER_PID] = [...r[a.OVERUSESHIPPER_PID] || [], a];
        return r;
      }, {})
  
      let total2 = exitDataList.sort(compare).reduce((r, a) => {
  
        r[a.OVERUSESHIPPER_PID] = [...r[a.OVERUSESHIPPER_PID] || [], a];
        return r;
      }, {})
      let totalData1 = []
      Object.keys(total1).map(key => {
        let temp = total1[key].reduce((total, row) => {
  
          total.OVERUSE_BOOKING = total.OVERUSE_BOOKING + row.OVERUSE_BOOKING
          total.OVERUSE_ACTUAL = total.OVERUSE_ACTUAL + row.OVERUSE_ACTUAL
          total.OVERUSE = total.OVERUSE + row.OVERUSE
          total.SHIPPER_PRIORITY_FLAG = total1[key][0].SHIPPER_PRIORITY_FLAG
          return total
        }, { OVERUSE_BOOKING: 0, OVERUSE_ACTUAL: 0, OVERUSE: 0, SHIPPER_PRIORITY_FLAG: 0 })
        totalData1.push(temp)
      })
  
      let totalData2 = []
      Object.keys(total2).map(key => {
        let temp = total2[key].reduce((total, row) => {
       
          total.OVERUSE_BOOKING = total.OVERUSE_BOOKING + row.OVERUSE_BOOKING
          total.OVERUSE_ACTUAL = total.OVERUSE_ACTUAL + row.OVERUSE_ACTUAL
          total.OVERUSE = total.OVERUSE + row.OVERUSE
          total.SHIPPER_PRIORITY_FLAG = total2[key][0].SHIPPER_PRIORITY_FLAG
          return total
        }, { OVERUSE_BOOKING: 0, OVERUSE_ACTUAL: 0, OVERUSE: 0, SHIPPER_PRIORITY_FLAG: 0 })
        totalData2.push(temp)
      })
 
      return {
        shippers: shipperList.sort(compare), overuseDataEntry: entryDataList.sort(compareArea).reduce((r, a) => {
          r[a.OVERUSE_AREA] = [...r[a.OVERUSE_AREA] || [], a];
          return r;
        }, {}), overuseDataExit: exitDataList.sort(compareArea).reduce((r, a) => {
          r[a.OVERUSE_AREA] = [...r[a.OVERUSE_AREA] || [], a];
          return r;
        }, {}),
        total: { entry: totalData1, exit: totalData2 }
      }
    }
    let shipperDataList = []
    if(shipperList.length>0){
      if(shipperList.length>4){
        let tempShipperList = [...shipperList] 
        let y =Math.ceil(tempShipperList.length/4);
        let dataPerTable =Math.ceil(tempShipperList.length/y);
        // console.log(tempShipperList.length,y,dataPerTable)
          for(let i = 0;i<y;i++){
            let temp= tempShipperList.splice(0,dataPerTable)
     
           let shipper = splitShipper(data,temp)
           shipperDataList.push(shipper)
          }
      }else{
  
        let shipper = splitShipper(data,shipperList)
        shipperDataList.push(shipper)
      }
      // console.log(shipperDataList)
      setDataList(shipperDataList)
    }
   
  }


  return (


    <Row className="mt-3">
      <Col lg="12">
        {/* <div className="table-responsive">
          <Table className="table table-bordered mb-0">
            <thead>
              <tr>
                <th
                  colSpan={(shippers.length * 3) + 1}
                  style={{
                    backgroundColor: "#556ee64a",
                    color: "#7AE3F7",
                    textAlign: "center",
                    width: "100%",
                  }}
                >
                  Capacity Overuse
                </th>
              </tr>
              <tr>
                <th
                  rowSpan={2}
                  style={{
                    backgroundColor: "#556ee678",
                    color: "#7AE3F7",
                    textAlign: "center",
                  }}
                >
                  Area
                </th>
                {shippers.map((shipper, index) => {
                  return (
                    <th
                      key={shipper.SHIPPER_NAME}
                      colSpan={3}
                      style={{
                        backgroundColor:
                          index % 2 == 0 ? "#5868b785" : "#667eef85",
                        color: "#7AE3F7",
                        textAlign: "center",
                      }}
                    >
                      {shipper.SHIPPER_NAME}
                    </th>
                  );
                })}

              </tr>
              <tr>{renderSubColumn()}</tr>
            </thead>
            {props.summaryReportPid && <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
              {Object.keys(overuseDataEntry).map(item => {
                return (
                  <tr key={item}>
                    <td>{item}</td>
                    {overuseDataEntry[item].sort((a, b) => (a.SHIPPER_PRIORITY_FLAG > b.SHIPPER_PRIORITY_FLAG) ? 1 : ((b.SHIPPER_PRIORITY_FLAG > a.SHIPPER_PRIORITY_FLAG) ? -1 : 0)).map(value => {
                      return (
                        <React.Fragment key={value.PID}>
                          <td><p>{numberFormat(value.OVERUSE_BOOKING / 1000, 0)}</p></td>
                          <td><p>{numberFormat(value.OVERUSE_ACTUAL / 1000, 0)}</p></td>
                          <td style={{ ...(value.OVERUSE / 1000).toFixed(0) > 0 && ({ color: 'rgb(240, 20, 6)' }) }}><p>{numberFormat(value.OVERUSE / 1000, 0)}</p></td>
                        </React.Fragment>
                      )
                    })}
                  </tr>
                )

              })}
              <tr style={{ backgroundColor: "#556ee630" }}>
                <td>Total</td>
                {total.entry.sort((a, b) => (a.SHIPPER_PRIORITY_FLAG > b.SHIPPER_PRIORITY_FLAG) ? 1 : ((b.SHIPPER_PRIORITY_FLAG > a.SHIPPER_PRIORITY_FLAG) ? -1 : 0)).map((value, index) => {
                  return (
                    <React.Fragment key={index.toString()}>
                      <td><p>{numberFormat(value.OVERUSE_BOOKING / 1000, 0)}</p></td>
                      <td><p>{numberFormat(value.OVERUSE_ACTUAL / 1000, 0)}</p></td>
                      <td style={{ ...(value.OVERUSE / 1000).toFixed(0) > 0 && ({ color: 'rgb(240, 20, 6)' }) }}><p>{numberFormat(value.OVERUSE / 1000, 0)}</p></td>
                    </React.Fragment>
                  )
                })}
              </tr>
              {Object.keys(overuseDataExit).map(item => {
                return (
                  <tr key={item}>
                    <td>{item}</td>
                    {overuseDataExit[item].sort((a, b) => (a.SHIPPER_PRIORITY_FLAG > b.SHIPPER_PRIORITY_FLAG) ? 1 : ((b.SHIPPER_PRIORITY_FLAG > a.SHIPPER_PRIORITY_FLAG) ? -1 : 0)).map(value => {
                      return (
                        <React.Fragment key={value.PID}>
                          <td><p>{numberFormat(value.OVERUSE_BOOKING / 1000, 0)}</p></td>
                          <td><p>{numberFormat(value.OVERUSE_ACTUAL / 1000, 0)}</p></td>
                          <td style={{ ...(value.OVERUSE / 1000).toFixed(0) > 0 && ({ color: 'rgb(240, 20, 6)' }) }}><p>{numberFormat(value.OVERUSE / 1000, 0)}</p></td>
                        </React.Fragment>
                      )
                    })}
                  </tr>
                )

              })}
              <tr style={{ backgroundColor: "#556ee630" }}>
                <td>Total</td>
                {total.exit.sort((a, b) => (a.SHIPPER_PRIORITY_FLAG > b.SHIPPER_PRIORITY_FLAG) ? 1 : ((b.SHIPPER_PRIORITY_FLAG > a.SHIPPER_PRIORITY_FLAG) ? -1 : 0)).map((value, index) => {
                  return (<React.Fragment key={index.toString()}>
                    <td><p>{numberFormat(value.OVERUSE_BOOKING / 1000, 0)}</p></td>
                    <td><p>{numberFormat(value.OVERUSE_ACTUAL / 1000, 0)}</p></td>
                    <td style={{ ...(value.OVERUSE / 1000).toFixed(0) > 0 && ({ color: 'rgb(240, 20, 6)' }) }}><p>{numberFormat(value.OVERUSE / 1000, 0)}</p></td>
                  </React.Fragment>)
                })}
              </tr>
            </tbody>
            }
          </Table>

        </div> */}
        {dataList.map((row, index) => <TableOveruseByShipper key={index.toString()} shippers={row.shippers} overuseDataEntry={row.overuseDataEntry} overuseDataExit={row.overuseDataExit} total={row.total} />

        )}
      </Col>
    </Row>


  );
}

OveruseByShipper.propTypes = {
  t: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
};

export default OveruseByShipper;
